import React from 'react';
import { DropdownMenuSeparator } from '../atoms/dropdown-menu';
import { Button } from '../atoms/button';

export type SyncToastProps = {
  open: boolean;
  progress: number;
  total: number;
  expanded: boolean;
  onClose: () => void;
  onToggleExpand: (value: boolean) => void;
};

const SyncToast: React.FC<SyncToastProps> = ({ open, progress, total, expanded, onClose, onToggleExpand }) => {
  if (!open) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-5">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
        {progress < total ? (
          <>
            {expanded ? (
              <div className="py-4 px-2 min-w-[287px]">
                <button
                  onClick={() => onToggleExpand(false)}
                  className="absolute right-3 top-2"
                  aria-label="Collapse sync toast"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500">
                    <path d="M3.33203 8H12.6654" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <div className="flex flex-col items-center gap-1">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48">
    <path fill="#FFC107" d="M17 6L31 6 45 30 31 30z"></path>
    <path fill="#1976D2" d="M9.875 42L16.938 30 45 30 38 42z"></path>
    <path fill="#4CAF50" d="M3 30.125L9.875 42 24 18 17 6z"></path>
  </svg>
  <span>Drive</span>
</div>

                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-[12px] text-gray-800 mb-0 text-center">Google Drive Folder Linked Successfully!</h3>
                    <p className="text-[10px] text-gray-800 text-center">
                      Your folder is now connected. New files will sync automatically.
                    </p>
                  </div>
                </div>
                <DropdownMenuSeparator className="bg-[#F5F5F5] my-2 mx-0" />
                <div className="space-y-3 mb-3">
                  <div className="flex items-center gap-2 text-[10px] text-[#414651]">
                    <span>Syncing files from your folder ...</span>
                    <span className="ml-auto">{total > 0 ? `${progress} of ${total}` : 'Starting...'}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-[#17B26A] h-2 rounded-full transition-all duration-300"
                      style={{ width: total > 0 ? `${(progress / total) * 100}%` : '10%' }}
                    ></div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-3 min-w-[280px]">
                <div className="flex items-center justify-between gap-3">
                  <button
                    onClick={() => onToggleExpand(true)}
                    className="absolute right-3"
                    aria-label="Expand sync toast"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-900">
                      <path d="M7.9987 3.33301V12.6663M3.33203 7.99967H12.6654" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-[10px] text-[#414651] truncate">
                      Syncing files from your folder {total > 0 ? `(${progress} of ${total})` : '(Starting...)'} ...
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="py-4 px-2 min-w-[287px] relative">
            <div className="flex flex-col items-center">
              <button
                onClick={onClose}
                className="absolute right-3 top-2"
                aria-label="Close toast"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="flex items-center justify-center flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M18.3346 9.23355V10.0002C18.3336 11.7972 17.7517 13.5458 16.6757 14.9851C15.5998 16.4244 14.0874 17.4773 12.3641 17.9868C10.6408 18.4963 8.79902 18.4351 7.11336 17.8124C5.4277 17.1896 3.98851 16.0386 3.01044 14.5311C2.03236 13.0236 1.56779 11.2403 1.68603 9.44714C1.80427 7.65402 2.49897 5.94715 3.66654 4.58111C4.8341 3.21506 6.41196 2.26303 8.16479 1.867C9.91763 1.47097 11.7515 1.65216 13.393 2.38355M18.3346 3.33355L10.0013 11.6752L7.50131 9.17521" stroke="#17B26A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div className="flex-1 min-w-0 mt-1">
                <h3 className="font-semibold text-gray-800 text-[12px] mb-0 text-center">All files synced!</h3>
                <p className="text-[10px] text-gray-800 text-center">
                  All your files are now synced and you can start to your project.
                </p>
              </div>
            </div>
            <Button
              onClick={onClose}
              className="w-full mt-4 px-3 py-2 bg-transparent text-[#414651] text-sm border border-[#D5D7DA] font-semibold rounded-md hover:bg-primary-700 hover:text-white"
            >
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SyncToast;
